import React from 'react';
import { UserCheck, BadgeCheck, Zap, IndianRupee, Award, Phone } from 'lucide-react';

const ICON_MAP = { UserCheck, BadgeCheck, Zap, IndianRupee, Award, Phone };

const DEFAULT_FEATURES = [
  { icon: 'UserCheck', title: 'Expert Technicians', description: 'Certified professionals for all RO brands' },
  { icon: 'BadgeCheck', title: 'Genuine Parts', description: '100% authentic spare parts with warranty' },
  { icon: 'Zap', title: 'Quick Service', description: 'Same-day service across Jaipur' },
  { icon: 'IndianRupee', title: 'Affordable Pricing', description: 'Transparent pricing, no hidden charges' },
  { icon: 'Award', title: 'Warranty Support', description: 'Service warranty on all repairs' },
  { icon: 'Phone', title: '24/7 Support', description: 'Round-the-clock customer support' },
];

const DEFAULT_STATS = [
  { value: '5000+', label: 'Happy Families' },
  { value: '100%', label: 'Satisfaction' },
  { value: '10+', label: 'Years Experience' },
  { value: 'All', label: 'RO Brands' },
];

const WhyChooseUs = ({ cms }) => {
  const d = cms || {};
  const title = d.title || 'Why Choose RO Dekho?';
  const subtitle = d.subtitle || 'Why Us';
  const features = d.reasons || d.features || DEFAULT_FEATURES;
  const stats = d.stats || DEFAULT_STATS;

  return (
    <section id="why-us" className="py-16 md:py-24 bg-[#0a1628] reveal-on-scroll" data-testid="why-choose-us-section">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <p className="text-xs sm:text-sm font-semibold text-lime-400 uppercase tracking-wider mb-3">{subtitle}</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
            {title.includes('RO Dekho') ? <>{title.replace('RO Dekho', '')}<span className="text-lime-400">RO Dekho</span>?</> : title}
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5 max-w-5xl mx-auto mb-10 sm:mb-14">
          {features.map((item, i) => {
            const Icon = ICON_MAP[item.icon] || UserCheck;
            return (
              <div key={i} className="bg-white/[0.04] hover:bg-white/[0.08] border border-white/[0.08] rounded-xl p-4 sm:p-6 transition-all group" data-testid={`why-feature-${i}`}>
                <div className="p-2 sm:p-2.5 bg-lime-400/10 rounded-lg inline-flex mb-2.5 sm:mb-3 group-hover:bg-lime-400/20 transition-colors">
                  <Icon className="text-lime-400" size={20} />
                </div>
                <h3 className="text-xs sm:text-sm md:text-base font-bold text-white mb-0.5 sm:mb-1">{item.title}</h3>
                <p className="text-[10px] sm:text-xs md:text-sm text-blue-200/40 hidden sm:block">{item.description}</p>
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 max-w-4xl mx-auto">
          {stats.map((stat, i) => (
            <div key={i} className="text-center py-4 sm:py-5 border border-white/[0.06] rounded-xl bg-white/[0.02]" data-testid={`trust-stat-${i}`}>
              <div className="text-xl sm:text-2xl md:text-3xl font-bold text-lime-400 mb-0.5">{stat.value}</div>
              <div className="text-[10px] sm:text-xs md:text-sm text-blue-200/40">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
